import React from 'react';
import SettingsPage from '@/pageComponents/Settings';

const DocumentDefaults = () => (
    <SettingsPage pathname="/settings/document-defaults" />
);

export default DocumentDefaults;
